import { alpha, styled } from '@mui/material'

export const Skeleton = styled('span', {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'color',
})<{ color?: 'default' | 'primary' | 'inverted' }>(({ theme, color }) => ({
  '&::after': {
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
    animation: 'skeleton-shimmer 1.4s infinite',
    background: `linear-gradient(90deg, transparent, ${alpha(
      theme.palette.common.white,
      theme.palette.mode === 'dark' ? 0.08 : 0.55,
    )}, transparent)`,
    content: '""',
    inset: 0,
    position: 'absolute',
    transform: 'translateX(-100%)',
  },
  '@keyframes skeleton-shimmer': {
    to: {
      transform: 'translateX(100%)',
    },
  },
  // The default used to be `background.paper` — the very surface skeletons are
  // drawn on, so every loading state rendered as blank white. A tint of the
  // text colour reads on paper and on the raised surfaces, in both modes.
  background:
    color === 'primary'
      ? theme.palette.primary.main
      : color === 'inverted'
        ? theme.palette.background.default
        : alpha(theme.palette.text.primary, 0.08),
  borderRadius: 4,
  display: 'block',
  height: '0.8em',
  margin: '0.2em 0',
  overflow: 'hidden',
  position: 'relative',
}))
